var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 1.93945C12.8235 2.53626 14.0278 3.28443 15.417 3.92188C16.8464 4.57776 18.5131 5.13396 20.1865 5.2666C20.2363 7.69641 20.4606 10.3338 19.6152 13.1436C18.7496 16.0206 16.7293 19.1162 11.999 22.1143C7.24637 19.1105 5.23499 16.1696 4.37695 13.3838C3.53059 10.6358 3.76809 7.99526 3.81348 5.2666C5.48659 5.13388 7.15286 4.57764 8.58203 3.92188C9.97075 3.28465 11.1746 2.53616 11.999 1.93945Z",
    stroke: "#B1B1BE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8156 9.58365C15.9166 9.68182 15.9166 9.844 15.8156 9.94217L10.7867 14.8306C10.6897 14.9249 10.5352 14.9249 10.4382 14.8306L8.18441 12.6397C8.08342 12.5416 8.08342 12.3794 8.18441 12.2812L8.61057 11.867C8.70759 11.7726 8.86205 11.7726 8.95908 11.867L10.4382 13.3048C10.5352 13.3991 10.6897 13.3991 10.7867 13.3048L15.0409 9.16939C15.1379 9.07507 15.2924 9.07507 15.3894 9.16939L15.8156 9.58365Z",
    fill: "#B1B1BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompliance);
export default __webpack_public_path__ + "static/media/ic_compliance.040dec256f30294afd18ffb8ba4ff020.svg";
export { ForwardRef as ReactComponent };